export default {
    "__schema": {
        "types": [
            {
                "kind": "INTERFACE",
                "name": "ActivitySession",
                "possibleTypes": [
                    {
                        "name": "BasicActivitySession"
                    },
                    {
                        "name": "MasteryActivitySession"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "AdminAggregate",
                "possibleTypes": [
                    {
                        "name": "District"
                    },
                    {
                        "name": "MetaDistrict"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "AdminNode",
                "possibleTypes": [
                    {
                        "name": "MetaDistrict"
                    },
                    {
                        "name": "District"
                    },
                    {
                        "name": "School"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "AssessmentStep",
                "possibleTypes": [
                    {
                        "name": "EYTQuestion"
                    },
                    {
                        "name": "StandardQuestion"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "Card",
                "possibleTypes": [
                    {
                        "name": "ProblemCard"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "ContentItemProgress",
                "possibleTypes": [
                    {
                        "name": "ArticleItemProgress"
                    },
                    {
                        "name": "AssessmentItemProgress"
                    },
                    {
                        "name": "BaseContentItemProgress"
                    },
                    {
                        "name": "ChallengeItemProgress"
                    },
                    {
                        "name": "ExerciseItemProgress"
                    },
                    {
                        "name": "InteractiveItemProgress"
                    },
                    {
                        "name": "ProjectItemProgress"
                    },
                    {
                        "name": "ScratchpadItemProgress"
                    },
                    {
                        "name": "SimpleContentItemProgress"
                    },
                    {
                        "name": "TalkthroughItemProgress"
                    },
                    {
                        "name": "VideoItemProgress"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "ContentRevision",
                "possibleTypes": [
                    {
                        "name": "AIGuideActivityRevision"
                    },
                    {
                        "name": "ArticleRevision"
                    },
                    {
                        "name": "AssessmentItemRevision"
                    },
                    {
                        "name": "ChallengeRevision"
                    },
                    {
                        "name": "CourseMenuRevision"
                    },
                    {
                        "name": "CurationPageRevision"
                    },
                    {
                        "name": "DomainRevision"
                    },
                    {
                        "name": "ExerciseRevision"
                    },
                    {
                        "name": "InteractiveRevision"
                    },
                    {
                        "name": "ProjectRevision"
                    },
                    {
                        "name": "TalkthroughRevision"
                    },
                    {
                        "name": "VideoRevision"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "CourseChild",
                "possibleTypes": [
                    {
                        "name": "Lesson"
                    },
                    {
                        "name": "Unit"
                    },
                    {
                        "name": "Course"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "CourseItem",
                "possibleTypes": [
                    {
                        "name": "CourseRevisionUnit"
                    },
                    {
                        "name": "CourseRevisionQuiz"
                    },
                    {
                        "name": "CourseRevisionLesson"
                    },
                    {
                        "name": "CourseRevisionContent"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "CourseRevisionItemInterface",
                "possibleTypes": [
                    {
                        "name": "CourseRevisionContent"
                    },
                    {
                        "name": "CourseRevisionLesson"
                    },
                    {
                        "name": "CourseRevisionQuiz"
                    },
                    {
                        "name": "CourseRevisionUnit"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "CurationDataModule",
                "possibleTypes": [
                    {
                        "name": "ActionListModule"
                    },
                    {
                        "name": "BrowseProjectsModule"
                    },
                    {
                        "name": "ClassHelpModule"
                    },
                    {
                        "name": "ContentCarouselModule"
                    },
                    {
                        "name": "CourseExperienceUpsellModule"
                    },
                    {
                        "name": "CourseIntroModule"
                    },
                    {
                        "name": "DualIntroModule"
                    },
                    {
                        "name": "FeaturedContentModule"
                    },
                    {
                        "name": "FullBleedImageModule"
                    },
                    {
                        "name": "KhanKidsUpsellModule"
                    },
                    {
                        "name": "MappersModule"
                    },
                    {
                        "name": "MissionCalloutModule"
                    },
                    {
                        "name": "PartnershipDescriptionModule"
                    },
                    {
                        "name": "SocialLinksModule"
                    },
                    {
                        "name": "TestimonialsModule"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "CurationItemProgress",
                "possibleTypes": [
                    {
                        "name": "CourseProgress"
                    },
                    {
                        "name": "SubjectProgress"
                    },
                    {
                        "name": "UnitProgress"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "CurationNode",
                "possibleTypes": [
                    {
                        "name": "Course"
                    },
                    {
                        "name": "Domain"
                    },
                    {
                        "name": "KMapTopic"
                    },
                    {
                        "name": "Lesson"
                    },
                    {
                        "name": "Topic"
                    },
                    {
                        "name": "Unit"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "CurationNodeProgress",
                "possibleTypes": [
                    {
                        "name": "CourseProgress"
                    },
                    {
                        "name": "SubjectProgress"
                    },
                    {
                        "name": "UnitProgress"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "DomainChild",
                "possibleTypes": [
                    {
                        "name": "CourseRevision"
                    },
                    {
                        "name": "CurationPageRevision"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "EditingSearchResult",
                "possibleTypes": [
                    {
                        "name": "ArticleRevision"
                    },
                    {
                        "name": "ExerciseRevision"
                    },
                    {
                        "name": "VideoRevision"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "Feedback",
                "possibleTypes": [
                    {
                        "name": "AnswerFeedback"
                    },
                    {
                        "name": "BasicFeedback"
                    },
                    {
                        "name": "QuestionFeedback"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "InterimAssessmentStep",
                "possibleTypes": [
                    {
                        "name": "InterimAssessmentStandardQuestionStep"
                    },
                    {
                        "name": "InterimAssessmentEYTQuestionStep"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "LearnableContent",
                "possibleTypes": [
                    {
                        "name": "AIGuideActivity"
                    },
                    {
                        "name": "Article"
                    },
                    {
                        "name": "Challenge"
                    },
                    {
                        "name": "Exercise"
                    },
                    {
                        "name": "Interactive"
                    },
                    {
                        "name": "LearnableCourseChallenge"
                    },
                    {
                        "name": "Project"
                    },
                    {
                        "name": "Talkthrough"
                    },
                    {
                        "name": "TopicQuiz"
                    },
                    {
                        "name": "TopicUnitTest"
                    },
                    {
                        "name": "Video"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "LearnableContentRevision",
                "possibleTypes": [
                    {
                        "name": "AIGuideActivityRevision"
                    },
                    {
                        "name": "ArticleRevision"
                    },
                    {
                        "name": "ChallengeRevision"
                    },
                    {
                        "name": "ExerciseRevision"
                    },
                    {
                        "name": "InteractiveRevision"
                    },
                    {
                        "name": "ProjectRevision"
                    },
                    {
                        "name": "TalkthroughRevision"
                    },
                    {
                        "name": "VideoRevision"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "LearnableNode",
                "possibleTypes": [
                    {
                        "name": "AIGuideActivity"
                    },
                    {
                        "name": "Article"
                    },
                    {
                        "name": "Challenge"
                    },
                    {
                        "name": "Exercise"
                    },
                    {
                        "name": "Interactive"
                    },
                    {
                        "name": "LearnableCourseChallenge"
                    },
                    {
                        "name": "LearnableMasteryChallenge"
                    },
                    {
                        "name": "Project"
                    },
                    {
                        "name": "Talkthrough"
                    },
                    {
                        "name": "TopicQuiz"
                    },
                    {
                        "name": "TopicUnitTest"
                    },
                    {
                        "name": "Video"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "LearnableRevisionResult",
                "possibleTypes": [
                    {
                        "name": "AIGuideActivityRevision"
                    },
                    {
                        "name": "ArticleRevision"
                    },
                    {
                        "name": "ExerciseRevision"
                    },
                    {
                        "name": "ChallengeRevision"
                    },
                    {
                        "name": "InteractiveRevision"
                    },
                    {
                        "name": "ProjectRevision"
                    },
                    {
                        "name": "TalkthroughRevision"
                    },
                    {
                        "name": "VideoRevision"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "LearningDashboardItem",
                "possibleTypes": [
                    {
                        "name": "ContentAssignment"
                    },
                    {
                        "name": "UnitPacingSuggestion"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "LearningMission",
                "possibleTypes": [
                    {
                        "name": "IntervalMission"
                    },
                    {
                        "name": "UnitMasteryMission"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "LearningTask",
                "possibleTypes": [
                    {
                        "name": "CourseChallengeTask"
                    },
                    {
                        "name": "MasteryChallengeTask"
                    },
                    {
                        "name": "PracticeTask"
                    },
                    {
                        "name": "SubjectChallengeTask"
                    },
                    {
                        "name": "TopicQuizTask"
                    },
                    {
                        "name": "TopicUnitTestTask"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "LessonChild",
                "possibleTypes": [
                    {
                        "name": "AIGuideActivity"
                    },
                    {
                        "name": "Article"
                    },
                    {
                        "name": "Exercise"
                    },
                    {
                        "name": "Video"
                    },
                    {
                        "name": "Challenge"
                    },
                    {
                        "name": "Interactive"
                    },
                    {
                        "name": "Talkthrough"
                    },
                    {
                        "name": "Project"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "MappedContent",
                "possibleTypes": [
                    {
                        "name": "AIGuideActivity"
                    },
                    {
                        "name": "Article"
                    },
                    {
                        "name": "Video"
                    },
                    {
                        "name": "Exercise"
                    },
                    {
                        "name": "Challenge"
                    },
                    {
                        "name": "Interactive"
                    },
                    {
                        "name": "Talkthrough"
                    },
                    {
                        "name": "Project"
                    },
                    {
                        "name": "TopicQuiz"
                    },
                    {
                        "name": "TopicUnitTest"
                    },
                    {
                        "name": "Topic"
                    },
                    {
                        "name": "Course"
                    },
                    {
                        "name": "Unit"
                    },
                    {
                        "name": "Lesson"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "Notification",
                "possibleTypes": [
                    {
                        "name": "AssignmentCreatedNotification"
                    },
                    {
                        "name": "AssignmentDueDateNotification"
                    },
                    {
                        "name": "AvatarNotification"
                    },
                    {
                        "name": "BadgeNotification"
                    },
                    {
                        "name": "BasicNotification"
                    },
                    {
                        "name": "CoachRequestAcceptedNotification"
                    },
                    {
                        "name": "CoachRequestNotification"
                    },
                    {
                        "name": "CourseMasteryDueDateCreatedNotification"
                    },
                    {
                        "name": "CourseMasteryGoalCreatedNotification"
                    },
                    {
                        "name": "GroupedBadgeNotification"
                    },
                    {
                        "name": "InfoNotification"
                    },
                    {
                        "name": "MasteryGoalDueDateApproachingCreatedNotification"
                    },
                    {
                        "name": "ModeratorNotification"
                    },
                    {
                        "name": "ProgramFeedbackNotification"
                    },
                    {
                        "name": "ResponseFeedbackNotification"
                    },
                    {
                        "name": "ThreadCreatedNotification"
                    },
                    {
                        "name": "UnitMasteryDueDateCreatedNotification"
                    },
                    {
                        "name": "UnitMasteryGoalCreatedNotification"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "ProgramContentRevision",
                "possibleTypes": [
                    {
                        "name": "ChallengeRevision"
                    },
                    {
                        "name": "InteractiveRevision"
                    },
                    {
                        "name": "ProjectRevision"
                    },
                    {
                        "name": "TalkthroughRevision"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "SiteEditorCurationNodeRevision",
                "possibleTypes": [
                    {
                        "name": "CurationPageRevision"
                    },
                    {
                        "name": "DomainRevision"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "SubmitAssignmentMutation",
                "possibleTypes": [
                    {
                        "name": "SubmitActivityAssignmentMutation"
                    },
                    {
                        "name": "SubmitWritingCoachAssignmentMutation"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "TAPContentItem",
                "possibleTypes": [
                    {
                        "name": "TAPAIGuideActivityNode"
                    },
                    {
                        "name": "TAPArticleNode"
                    },
                    {
                        "name": "TAPChallengeNode"
                    },
                    {
                        "name": "TAPCourseNode"
                    },
                    {
                        "name": "TAPDomainNode"
                    },
                    {
                        "name": "TAPExerciseNode"
                    },
                    {
                        "name": "TAPInteractiveNode"
                    },
                    {
                        "name": "TAPLessonNode"
                    },
                    {
                        "name": "TAPProjectNode"
                    },
                    {
                        "name": "TAPTalkthroughNode"
                    },
                    {
                        "name": "TAPUnitNode"
                    },
                    {
                        "name": "TAPVideoNode"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "TAPContentWordCounts",
                "possibleTypes": [
                    {
                        "name": "TAPArticleNode"
                    },
                    {
                        "name": "TAPChallengeNode"
                    },
                    {
                        "name": "TAPExerciseNode"
                    },
                    {
                        "name": "TAPPlatformNode"
                    },
                    {
                        "name": "TAPProjectNode"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "TAPLearnableContentNode",
                "possibleTypes": [
                    {
                        "name": "TAPAIGuideActivityNode"
                    },
                    {
                        "name": "TAPArticleNode"
                    },
                    {
                        "name": "TAPChallengeNode"
                    },
                    {
                        "name": "TAPExerciseNode"
                    },
                    {
                        "name": "TAPInteractiveNode"
                    },
                    {
                        "name": "TAPProjectNode"
                    },
                    {
                        "name": "TAPTalkthroughNode"
                    },
                    {
                        "name": "TAPVideoNode"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "TAPMetadataWordCounts",
                "possibleTypes": [
                    {
                        "name": "TAPAIGuideActivityNode"
                    },
                    {
                        "name": "TAPArticleNode"
                    },
                    {
                        "name": "TAPChallengeNode"
                    },
                    {
                        "name": "TAPCourseNode"
                    },
                    {
                        "name": "TAPDomainNode"
                    },
                    {
                        "name": "TAPExerciseNode"
                    },
                    {
                        "name": "TAPInteractiveNode"
                    },
                    {
                        "name": "TAPLessonNode"
                    },
                    {
                        "name": "TAPProjectNode"
                    },
                    {
                        "name": "TAPTalkthroughNode"
                    },
                    {
                        "name": "TAPUnitNode"
                    },
                    {
                        "name": "TAPVideoNode"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "TAPTranslationFreshness",
                "possibleTypes": [
                    {
                        "name": "TAPContentData"
                    },
                    {
                        "name": "TAPCourseData"
                    },
                    {
                        "name": "TAPDomainsData"
                    },
                    {
                        "name": "TAPFolderData"
                    },
                    {
                        "name": "TAPNodesData"
                    },
                    {
                        "name": "TAPPlatformData"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "TeacherCampaignStepInterface",
                "possibleTypes": [
                    {
                        "name": "TeacherCampaignAwardStep"
                    },
                    {
                        "name": "TeacherCampaignInfoStep"
                    },
                    {
                        "name": "TeacherCampaignResponseStep"
                    },
                    {
                        "name": "TeacherCampaignVideoStep"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "TopicChildren",
                "possibleTypes": [
                    {
                        "name": "Topic"
                    },
                    {
                        "name": "AIGuideActivity"
                    },
                    {
                        "name": "Article"
                    },
                    {
                        "name": "Challenge"
                    },
                    {
                        "name": "Exercise"
                    },
                    {
                        "name": "Interactive"
                    },
                    {
                        "name": "LearnableCourseChallenge"
                    },
                    {
                        "name": "Project"
                    },
                    {
                        "name": "Talkthrough"
                    },
                    {
                        "name": "TopicQuiz"
                    },
                    {
                        "name": "TopicUnitTest"
                    },
                    {
                        "name": "Video"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "UnitChild",
                "possibleTypes": [
                    {
                        "name": "TopicQuiz"
                    },
                    {
                        "name": "TopicUnitTest"
                    },
                    {
                        "name": "Lesson"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "UserEssayOriginalityFlag",
                "possibleTypes": [
                    {
                        "name": "UserEssayOriginalityFlagPasteIntoOutline"
                    },
                    {
                        "name": "UserEssayOriginalityFlagPasteIntoText"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "UserEssaySnapshot",
                "possibleTypes": [
                    {
                        "name": "UserEssayOutlineSnapshot"
                    },
                    {
                        "name": "UserEssayTextSnapshot"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "UserTask",
                "possibleTypes": [
                    {
                        "name": "CourseChallengeUserTask"
                    },
                    {
                        "name": "MasteryChallengeUserTask"
                    },
                    {
                        "name": "PracticeUserTask"
                    },
                    {
                        "name": "SubjectChallengeUserTask"
                    },
                    {
                        "name": "TopicQuizUserTask"
                    },
                    {
                        "name": "TopicUnitTestUserTask"
                    }
                ]
            },
            {
                "kind": "INTERFACE",
                "name": "YoutubeVideoInfo",
                "possibleTypes": [
                    {
                        "name": "YoutubeVideoInfoFromExistingContent"
                    },
                    {
                        "name": "YoutubeVideoInfoFromYoutube"
                    }
                ]
            }
        ]
    }
}